import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { SupplierDetailApi } from '../redux/actions/User/Detail/SupplierDetailAction';
import { useDispatch, useSelector } from 'react-redux';
import { PuffLoader, PulseLoader } from 'react-spinners';
import { showErrorToast, showSuccessToast } from '../helpers/SweetAlert';
import { useHeading } from '../context/HeadingContext';
import { GetSupplierProductsApi } from '../redux/actions/User/Detail/GetSupplierProductsAction';
import { addToCart, removeFromCart } from '../redux/slices/Cart/CartSlice';
import { cartButton, markItemAsAdded, setShowCartButtons, unmarkItemAsAdded } from '../redux/slices/Cart/CartUISlice';
import { GetSupplierCategoriesApi } from '../redux/actions/User/Detail/Filters/GetCategoryAction';
import { GetSupplierFiltersProductsApi } from '../redux/actions/User/Detail/Filters/GetProductAction';
import CartSyncHandler from '../components/CartSyncHandler'
import Swal from 'sweetalert2';
import { GetGeneratedOrdersApi, GetOrdersApi } from '../redux/actions/Supplier/GetGeneratedOrdersAction';
import backend_url from '../services/endpoints';
import { GetRecievedOrdersApi } from '../redux/actions/Supplier/GetRecievedOrdersAction';
import { formatDate, formatTime, formatTime12Hour } from '../helpers/formatDateTime';
import { ChangeOrderStatusAPI } from '../redux/actions/User/Detail/ChangeOrderStatusAction';
import { orderRequest } from '../redux/slices/Cart/OrderRequestSlice';
import { changeOrderStatusStateReset } from '../redux/slices/User/Detail/ChangeOrderStatusSlice';
import { GetCompletedOrdersApi } from '../redux/actions/Supplier/GetCompletedOrdersAction';
import InfiniteScroll from 'react-infinite-scroll-component';

const SupplierDetail = () => {
    const location = useLocation();
    const { setHeading } = useHeading();
    const filterDropdownToggleRef = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [tempProductType, setTempProductType] = useState("");
    const [selectedProductType, setSelectedProductType] = useState("");

    const [tempFilterCategory, setTempFilterCategory] = useState("");
    const [selectedFilterCategory, setSelectedFilterCategory] = useState("");

    const [requestGeneratedTempProductType, setRequestGeneratedTempProductType] = useState("");
    const [selectedRequestGeneratedProductType, setSelectedRequestGeneratedProductType] = useState("");

    const [requestGeneratedTempFilterCategory, setRequestGeneratedTempFilterCategory] = useState("");
    const [selectedRequestGeneratedFilterCategory, setSelectedRequestGeneratedFilterCategory] = useState("");


    const [requestRecievedTempProductType, setRequestRecievedTempProductType] = useState("");
    const [selectedRequestRecievedProductType, setSelectedRequestRecievedProductType] = useState("");

    const [requestRecievedTempFilterCategory, setRequestRecievedTempFilterCategory] = useState("");
    const [selectedRequestRecievedFilterCategory, setSelectedRequestRecievedFilterCategory] = useState("");

    const [selectedOrder, setSelectedOrder] = useState(null);

    const [showDateTimeFields, setShowDateTimeFields] = useState(false);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedTime, setSelectedTime] = useState('');
    const [validationErrors, setValidationErrors] = useState({ date: false, time: false });

    //products pagination params

    const [products, setProducts] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(5);
    const [hasMore, setHasMore] = useState(true);

    //request generated pagination params
    const [page1, setPage1] = useState(1);
    const [limit1, setLimit1] = useState(5);

    //request recieved pagination params
    const [page2, setPage2] = useState(1);
    const [limit2, setLimit2] = useState(5);

    //completed orders pagination params
    const [page3, setPage3] = useState(1);
    const [limit3, setLimit3] = useState(5);

    const [quantities, setQuantities] = useState({});

    const [productSearch, setProductSearch] = useState('');

    const [requestGeneratedSearch, setRequestGeneratedSearch] = useState('');

    const [requestRecievedSearch, setRequestRecievedSearch] = useState('');

    const addedToCartIndex = useSelector((state) => state.cartUI.addedToCartIndex);
    const cartButtonIndex = useSelector((state) => state.cartUI.showCartButtons)

    const cartItems = useSelector((state) => state.cart.items);

    const { response, error, loading } = useSelector((state) => state.getSupplierDetail);
    const { response: getProductsResponse, error: getProductsError, loading: getProductsLoading } = useSelector((state) => state.getSupplierProducts)
    const { response: getSuppliersProductTypesListResponse, error: getSuppliersProductTypesListError, loading: getSuppliersProductTypesListLoading } = useSelector((state) => state.getSupplierFilterProducts);
    const { response: getSuppliersCategoryListResponse, error: getSuppliersCategoryListError, loading: getSuppliersCategoryListLoading } = useSelector((state) => state.getSupplierFilterCategories);
    const { response: getSuppliersRequestGeneratedResponse, error: getSuppliersRequestGeneratedError, loading: getSuppliersRequestGeneratedLoading } = useSelector((state) => state.supplierGeneratedOrders)
    const { response: getSuppliersRequestRecievedResponse, error: getSuppliersRequestRecievedError, loading: getSuppliersRequestRecievedLoading } = useSelector((state) => state.supplierRecievedOrders)
    const { response: getSuppliersCompletedOrdersResponse, error: getSuppliersCompletedOrdersError, loading: getSuppliersCompletedOrdersLoading } = useSelector((state) => state.supplierCompletedOrders)
    const { response: changeOrderStatusResponse, error: changeOrderStatusError } = useSelector((state) => state.changeOrderStatus);
    // const id = location.state.id;    
    const { id } = useParams();

    const handleSearchChange = (e) => {
        setProductSearch(e.target.value);
        setPage(1);            // Always reset to page 1 for new search
        setProducts([]);
        setHasMore(true);
    };

    const handleRequestGeneratedSearchChange = (e) => {
        setRequestGeneratedSearch(e.target.value);
    };

    const handleRequestRecievedSearchChange = (e) => {
        setRequestRecievedSearch(e.target.value);
    };

    const handleGenerateRequest = () => {
        // setCartButtonShow(prev => !prev);
        // dispatch(cartButton(true))
        dispatch(setShowCartButtons(true));
    }

    const handleAddToCart = (data) => {
        // setAddedToCart((prev) => ({
        //     ...prev,
        //     [index]: true, // Set the specific card index to true
        // }));
        // setCartButtonShow(prev => !prev);
        const existingSupplier = cartItems.length > 0 ? cartItems[0].supplierId : null;

        if (existingSupplier && existingSupplier !== id) {
            Swal.fire({
                icon: 'warning',
                title: 'Oops!',
                text: 'You can only add products from one supplier at a time.',
                confirmButtonColor: '#3085d6',
            });
            return;
        }
        // dispatch(markItemAsAdded(index));
        dispatch(markItemAsAdded(data._id));
        dispatch(addToCart({ ...data, quantity: data.quantity, supplierId: data.supplierId }));
    };

    const fetchSupplierDetail = useCallback(() => {
        dispatch(SupplierDetailApi(id));
    }, [dispatch, id]);

    const fetchSupplierProducts = useCallback(() => {
        dispatch(GetSupplierProductsApi(productSearch, selectedFilterCategory, selectedProductType, id, page, limit));
    }, [dispatch, productSearch, selectedFilterCategory, selectedProductType, page, limit]);

    const fetchRequestGenerated = useCallback((type) => {

        const params = {
            supplierId: id,
            type: type,
            page: page1,
            limit: limit1
        };

        // if (type === 0) {
        //     Only add search/filter params if they have values
        //     if (requestGeneratedSearch) params.search = requestGeneratedSearch;
        //     if (selectedRequestGeneratedFilterCategory) params.category = selectedRequestGeneratedFilterCategory;
        //     if (selectedRequestGeneratedProductType) params.productType = selectedRequestGeneratedProductType;
        //     params.page = page1;
        //     params.limit = limit1;
        // }
        // else if (type === 1) {
        //     Only add search/filter params if they have values
        //     if (requestRecievedSearch) params.search = requestRecievedSearch;
        //     if (selectedRequestRecievedFilterCategory) params.category = selectedRequestRecievedFilterCategory;
        //     if (selectedRequestRecievedProductType) params.productType = selectedRequestRecievedProductType;
        //     params.page = page2;
        //     params.limit = limit2;
        // }

        dispatch(GetGeneratedOrdersApi(params));
    }, [dispatch, page1, limit1, id]);

    const fetchRequestRecieved = useCallback((type) => {
        const params = {
            supplierId: id,
            type: type,
            page: page2,
            limit: limit2
        };

        dispatch(GetRecievedOrdersApi(params));
    }, [dispatch, page2, limit2, id]);

    const fetchCompleteOrders = useCallback((type) => {
        const params = {
            supplierId: id,
            type: type,
            page: page3,
            limit: limit3
        };

        dispatch(GetCompletedOrdersApi(params));
    }, [dispatch, page3, limit3, id]);

    const getOrderStatus = (t) => {
        if (t == 0 || t == 7) {
            return 'Pending'
        }
        else if (t == 1) {
            return 'Accepted'
        }
        else if (t == 2) {
            return 'Rejected'
        }
        else if (t == 3) {
            return 'Cancelled'
        }
        else if (t == 4) {
            return 'Payment Pending'
        }
        else if (t == 5) {
            return 'Completed'
        }
        else if (t == 6) {
            return 'Reported'
        }
    }

    const handleRejectOrderRequest = async (orderId, status) => {
        try {
            const data = {
                orderId: orderId,
                status: status
            }
            dispatch(ChangeOrderStatusAPI(data))
        } catch (error) {
            console.log('error in reject order request', error)
        }
    }

    const handleAcceptOrderRequest = async (orderId, status) => {
        try {
            const data = {
                orderId: orderId,
                status: status,
                scheduledDate: selectedDate,
                scheduledTime: selectedTime
            }
            dispatch(ChangeOrderStatusAPI(data))
        } catch (error) {
            console.log('error in reject order request', error)
        }
    }

    useEffect(() => {
        fetchSupplierDetail(id);
    }, [location, id]);

    useEffect(() => {
        fetchSupplierProducts();
        fetchRequestRecieved(1);
        fetchRequestGenerated(2);
        fetchCompleteOrders(3);
    }, []);

    useEffect(() => {
        dispatch(GetSupplierFiltersProductsApi());
        dispatch(GetSupplierCategoriesApi());
    }, [])

    useEffect(() => {
        fetchSupplierProducts()
    }, [selectedFilterCategory, selectedProductType, productSearch, page, limit])

    useEffect(() => {
        if (!cartItems.length > 0) {
            dispatch(setShowCartButtons(false))
        }
    }, [cartItems])

    useEffect(() => {
        if (response?.data?.supplier?.firstName) {
            setHeading(response?.data?.supplier?.firstName);
        }
        else {
            setHeading(""); // Reset heading if no ownerName
        }
    }, [response, setHeading]);

    useEffect(() => {
        if (getProductsResponse?.status === true) {
            const newProducts = getProductsResponse?.data?.products || [];
            const totalCount = getProductsResponse?.data?.total || 0;

            if (page === 1) {
                setProducts(newProducts);
            } else {
                setProducts(prev => [...prev, ...newProducts]);
            }

            // Optional: update limit if coming from backend
            if (page === 1) {
                setLimit(getProductsResponse?.data?.limit || limit);
            }

            const totalLoaded = (page - 1) * limit + newProducts.length;
            if (totalLoaded >= totalCount) {
                setHasMore(false); // no more products
            }
        }
    }, [getProductsResponse]);

    useEffect(() => {
        if (getSuppliersRequestGeneratedResponse?.status === true) {
            setPage1(getSuppliersRequestGeneratedResponse?.data?.page);
            setLimit1(getSuppliersRequestGeneratedResponse?.data?.limit);
        }
    }, [getSuppliersRequestGeneratedResponse])


    useEffect(() => {
        if (getSuppliersRequestRecievedResponse?.status === true) {
            setPage2(getSuppliersRequestRecievedResponse?.data?.page);
            setLimit2(getSuppliersRequestRecievedResponse?.data?.limit);
        }
    }, [getSuppliersRequestRecievedResponse])


    useEffect(() => {
        if (getSuppliersCompletedOrdersResponse?.status === true) {
            setPage3(getSuppliersCompletedOrdersResponse?.data?.page);
            setLimit3(getSuppliersCompletedOrdersResponse?.data?.limit);
        }
    }, [getSuppliersCompletedOrdersResponse])

    useEffect(() => {
        setProductSearch('');
        setRequestGeneratedSearch('');
        setRequestRecievedSearch('');
    }, [location])

    useEffect(() => {
        if (changeOrderStatusResponse?.status === true) {
            showSuccessToast(changeOrderStatusResponse?.message);
            dispatch(changeOrderStatusStateReset());
            fetchSupplierProducts();
            fetchRequestRecieved(1);
            fetchRequestGenerated(2);
            const modalElement = document.getElementById('detailModal');
            const modal = window.bootstrap.Modal.getInstance(modalElement);
            if (modal) {
                modal.hide();
            } else {
                const newModal = new window.bootstrap.Modal(modalElement);
                newModal.hide();
            }
        }
    }, [changeOrderStatusResponse, fetchSupplierProducts, fetchRequestRecieved, fetchRequestGenerated])

    useEffect(() => {
        if (error) {
            showErrorToast(error?.data || "Something went wrong");
        }
        if (getProductsError) {
            showErrorToast(getProductsError?.data || "Something went wrong");
        }
        if (getSuppliersRequestGeneratedError) {
            showErrorToast(getSuppliersRequestGeneratedError?.data || "Something went wrong");
        }
        if (getSuppliersRequestRecievedError) {
            showErrorToast(getSuppliersRequestRecievedError?.data || "Something went wrong");
        }
        if (getSuppliersCompletedOrdersError) {
            showErrorToast(getSuppliersCompletedOrdersError?.data || "Something went wrong");
        }
        if (changeOrderStatusError) {
            showErrorToast(changeOrderStatusError?.data || "Something went wrong");
            dispatch(changeOrderStatusStateReset);

        }
    }, [error, getProductsError, getSuppliersRequestGeneratedError, getSuppliersRequestRecievedError, getSuppliersCompletedOrdersError, changeOrderStatusError]);

    return (
        <>
            {loading ? (
                <div style={{ height: '70vh' }} className='d-flex align-items-center justify-content-center text-center'>
                    <PulseLoader size={85} color="#0f0a30" />
                </div>
            ) : (
                <section className='main'>
                    <div className='container'>
                        <div className='row gy-4'>
                            <div className='col-12'>
                                <div className="wrapper-card">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className='hstack flex-wrap gap-3'>
                                                <div className='supp_img'>
                                                    <img src={response?.data?.supplier?.image ? `${backend_url}${response?.data?.supplier?.image}` : '/assets/images/user.png'} alt="Supplier" />
                                                </div>
                                                <div className="info_content">
                                                    <div className='supplier_name_blk mb-3'>
                                                        <h3 className='fw-bold mb-0'>{response?.data?.supplier?.firstName || 'N/A'}</h3>
                                                    </div>
                                                    <div className="info_content-row hstack flex-wrap">
                                                        <div className="info-detail">
                                                            <h2 className="h4">Location</h2>
                                                            <p className="mb-0">{[
                                                                response?.data?.supplier?.street,
                                                                response?.data?.supplier?.city,
                                                                response?.data?.supplier?.state,
                                                                response?.data?.supplier?.country
                                                            ]
                                                                .filter(Boolean)  // removes undefined, null, empty string
                                                                .join(", ")}</p>
                                                        </div>
                                                        <div className="info-detail">
                                                            <h2 className="h4">Contact Number</h2>
                                                            <p className="mb-0">{response?.data?.supplier?.phoneNumber || 'N/A'}</p>
                                                        </div>
                                                        <div className="info-detail">
                                                            <h2 className="h4">Email Address</h2>
                                                            <p className="mb-0">{response?.data?.supplier?.email || 'N/A'}</p>
                                                        </div>
                                                        {/* <div className="info-detail">
                                                            <h2 className="h4">Type of Product</h2>
                                                            <p className="mb-0">{response?.data?.supplier?.product || 'N/A'}</p>
                                                        </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12'>
                                <div className='wrapper-card income_card d-inline-flex flex-column align-items-center'>
                                    <span className='income_title'>Total Income</span>
                                    <span className='income_amount'>{`$0`}</span>
                                </div>
                            </div>
                            <div className='col-12'>
                                <div className='common_tabs'>
                                    <nav>
                                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                            <button className="nav-link active" id="nav-cmt-1-tab" data-bs-toggle="tab" data-bs-target="#nav-cmt-1" type="button" role="tab" aria-controls="nav-cmt-1" aria-selected="true">Product</button>
                                            <button className="nav-link" id="nav-cmt-2-tab" data-bs-toggle="tab" data-bs-target="#nav-cmt-2" type="button" role="tab" aria-controls="nav-cmt-2" aria-selected="false">Request Generated</button>
                                            <button className="nav-link" id="nav-cmt-3-tab" data-bs-toggle="tab" data-bs-target="#nav-cmt-3" type="button" role="tab" aria-controls="nav-cmt-3" aria-selected="false">Requests Received</button>
                                            <button className="nav-link" id="nav-cmt-4-tab" data-bs-toggle="tab" data-bs-target="#nav-cmt-4" type="button" role="tab" aria-controls="nav-cmt-4" aria-selected="false">Completed Orders</button>
                                        </div>
                                    </nav>
                                    < div className="tab-content wrapper-card" id="nav-tabContent">
                                        <div className="tab-pane fade show active" id="nav-cmt-1" role="tabpanel" aria-labelledby="nav-cmt-1-tab" tabIndex={0}>
                                            <div className='d-flex justify-content-between align-items-start flex-wrap gap-3'>
                                                <div className='search_filter_blk hstack'>
                                                    <div className='search_blk position-relative'>
                                                        <input type="search" className='form-control' placeholder='Search something.....' onKeyDown={(e) => {
                                                            const value = e.target.value;
                                                            // Prevent space if the input is still empty or only contains spaces
                                                            if (e.key === ' ' && value.trim().length === 0) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                            onChange={handleSearchChange} value={productSearch} />
                                                        <span class="search-icon"></span>
                                                    </div>
                                                    <div className='filter_blk position-relative'>
                                                        <button className='filter_btn dropdown-toggle' type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" ref={filterDropdownToggleRef}>
                                                            <img src='/assets/icons/filter-icon.svg' />
                                                        </button>
                                                        <div className="filter_drop dropdown-menu dropdown-menu-end p-4">
                                                            <h3 className='filter_heading fs-6 fw-semibold mb-3'>Filter by</h3>
                                                            <div className='filter_fields mt-1'>
                                                                <label>Type of Product</label>

                                                                <select className='form-select' value={tempProductType}
                                                                    onChange={(e) => setTempProductType(e.target.value)}>
                                                                    {(getSuppliersProductTypesListError || getSuppliersProductTypesListLoading) ? (
                                                                        <option>Nothing to show</option>
                                                                    ) : (
                                                                        <>
                                                                            <option>Select Product Type</option>
                                                                            {getSuppliersProductTypesListResponse?.data?.map((g, index) => (
                                                                                <option key={index} value={g._id}>
                                                                                    {g.name}
                                                                                </option>
                                                                            ))}
                                                                        </>
                                                                    )}
                                                                </select>

                                                            </div>
                                                            <div className='filter_fields mt-1'>
                                                                <label>Category</label>
                                                                <select className='form-select' value={tempFilterCategory}
                                                                    onChange={(e) => setTempFilterCategory(e.target.value)}>
                                                                    {(getSuppliersCategoryListError || getSuppliersCategoryListLoading) ? (
                                                                        <option>Nothing to show</option>
                                                                    ) : (
                                                                        <>
                                                                            <option>Select Category</option>
                                                                            {getSuppliersCategoryListResponse?.data?.map((g, index) => (
                                                                                <option key={index} value={g._id}>
                                                                                    {g.name}
                                                                                </option>
                                                                            ))}
                                                                        </>
                                                                    )}
                                                                </select>
                                                            </div>
                                                            <div className='d-flex justify-content-center align-items-center flex-wrap gap-2 mt-4'>
                                                                <button className='primary-btn p-1' onClick={() => {
                                                                    setSelectedProductType(tempProductType);
                                                                    setSelectedFilterCategory(tempFilterCategory);

                                                                    if (filterDropdownToggleRef.current) {
                                                                        const dropdown = window.bootstrap.Dropdown.getOrCreateInstance(filterDropdownToggleRef.current);
                                                                        dropdown.hide();
                                                                    }
                                                                    // trigger your filtering function or API call here
                                                                }}>Apply</button>
                                                                <button className='transparent-btn p-1' onClick={() => {
                                                                    setTempProductType("");
                                                                    setTempFilterCategory("");
                                                                    setSelectedProductType("");
                                                                    setSelectedFilterCategory("")
                                                                    if (filterDropdownToggleRef.current) {
                                                                        const dropdown = window.bootstrap.Dropdown.getOrCreateInstance(filterDropdownToggleRef.current);
                                                                        dropdown.hide();
                                                                    }

                                                                }}>Cancel</button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className='btn_blk hstack'>
                                                    {(cartButtonIndex) ? (cartItems.length > 0) ? (
                                                        <button className='primary-btn hstack justify-content-center gap-1' onClick={() => navigate('/admin-dashboard/cart')}><img src="/assets/icons/goto-cart-icon.svg" className='icon' />Go to Cart</button>
                                                    ) : (
                                                        <button className='primary-btn hstack justify-content-center gap-1' onClick={handleGenerateRequest}><img src="/assets/icons/gen-report-icon.svg" className='icon' />Generate Request</button>
                                                    ) :
                                                        cartItems.length > 0 ? (<button className='primary-btn hstack justify-content-center gap-1' onClick={() => navigate('/admin-dashboard/cart')}><img src="/assets/icons/goto-cart-icon.svg" className='icon' />Go to Cart</button>) : (
                                                            <button className='primary-btn hstack justify-content-center gap-1' onClick={handleGenerateRequest}><img src="/assets/icons/gen-report-icon.svg" className='icon' />Generate Request</button>
                                                        )}


                                                </div>
                                            </div>
                                            {/* <div className='product_listing_blk'>
                                                            <div className='product_card'>
                                                                <div className='product_img'>
                                                                    <img src="/assets/images/fruit-apple.png" alt="product" />
                                                                </div>
                                                                <div className='product_info'>
                                                                    <div className='hstack flex-wrap justify-content-between gap-2'>
                                                                        <h3 className='product_name fs-6 fw-bold mb-0'>Apple</h3>
                                                                        <span className='product_qty primary_text fs-6 fw-bold'>$4/Kg</span>
                                                                    </div>
                                                                    <span className='product_type fw-medium'>Organic</span>
                                                                </div>
                                                                <div className='add_to_card_action_blk'>
                                                                    <button className='w-100 primary-btn hstack justify-content-center gap-1'><img src="/assets/icons/goto-cart-icon.svg" className='icon' />Add to Cart</button>
                                                                    <div className='add_qty_counter'>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> */}
                                            <CartSyncHandler />
                                            {/* Products Mapping */}
                                            <div id="scrollableDiv" style={{ height: '260px', overflowY: 'auto', marginTop: '30px' }}>
                                                <InfiniteScroll
                                                    dataLength={products.length}
                                                    next={() => {
                                                        setPage(prev => prev + 1);
                                                    }}
                                                    hasMore={hasMore}
                                                    loader={<h4>Loading...</h4>}
                                                    scrollThreshold={0.9}
                                                    scrollableTarget="scrollableDiv"
                                                >
                                                    <div className="product_listing_blk">
                                                        {Array.isArray(products) && products?.length > 0 ? (
                                                            products.map((product, index) => {
                                                                const itemInCart = cartItems.find((c) => c._id === product._id);
                                                                // const noItemsInCart = cartItems.filter(c => c._id === product._id);
                                                                const currentQty = itemInCart?.quantity || 1;

                                                                return (

                                                                    <div className="product_card" key={index} >
                                                                        <div className="product_img">
                                                                            <img
                                                                                src={product.img ? `${backend_url}${product.img}` : "/assets/images/fruit-apple.png"} // fallback if no image
                                                                                alt={product.name || "product"}
                                                                            />
                                                                        </div>
                                                                        <div className="product_info">
                                                                            <div className="hstack flex-wrap justify-content-between gap-2">
                                                                                <h3 className="product_name fs-6 fw-bold mb-0">
                                                                                    {product.name || "Unknown Product"}
                                                                                </h3>
                                                                                <span className="product_qty primary_text fs-6 fw-bold">
                                                                                    {product.price ? (product.unitType ? `$${product.price}/${product.unitType}` : `$${product.price}`) : "N/A"}
                                                                                </span>
                                                                            </div>
                                                                            <span className="product_type fw-medium">
                                                                                {product.productType || "Organic"}
                                                                            </span>
                                                                        </div>
                                                                        <div className="add_to_card_action_blk">

                                                                            {(cartButtonIndex && !addedToCartIndex[product._id]) &&
                                                                                <button className="w-100 primary-btn hstack justify-content-center gap-1" onClick={() => {
                                                                                    const newQty = currentQty;
                                                                                    setQuantities((q) => ({ ...q, [product._id]: newQty }));
                                                                                    handleAddToCart({ ...product, quantity: newQty, supplierId: response.data.supplier._id })
                                                                                    // handleAddToCart(product._id);
                                                                                    // dispatch(addToCart({ ...product, quantity: newQty, supplierId: response.data.supplier._id }));
                                                                                }}>
                                                                                    <img src="/assets/icons/goto-cart-icon.svg" className="icon" />
                                                                                    Add to Cart
                                                                                </button>}

                                                                            {(addedToCartIndex[product._id] && itemInCart) && (<div className="add_qty_counter">
                                                                                <div className="value-button" id="decrease" value="Decrease Value"
                                                                                    // onClick={() => {
                                                                                    //     // Decrease the quantity locally
                                                                                    //     setQuantities((prev) => {

                                                                                    //         console.log(prev, "prev")
                                                                                    //         const updated = {
                                                                                    //             ...prev,
                                                                                    //             [product._id]: Math.max((prev[product._id] || 0) - 1, 0), // prevent going below 0
                                                                                    //         };


                                                                                    //         console.log(updated, "updated")
                                                                                    //         // Dispatch decrease action if quantity becomes 0
                                                                                    //         if (updated[product._id] === 0) {
                                                                                    //             dispatch(removeFromCart(product._id));  // Optionally, you can remove the item when quantity is 0
                                                                                    //         } else {
                                                                                    //             // Dispatch the updated quantity to cart
                                                                                    //             dispatch(addToCart({
                                                                                    //                 ...product,
                                                                                    //                 quantity: updated[product._id]
                                                                                    //             }));
                                                                                    //         }

                                                                                    //         return updated;
                                                                                    //     }
                                                                                    // );
                                                                                    // }
                                                                                    // }
                                                                                    onClick={() => {
                                                                                        if (currentQty <= 1) {
                                                                                            // Do nothing if quantity is already 1
                                                                                            return;
                                                                                        }
                                                                                        const newQty = Math.max(currentQty - 1, 0);
                                                                                        setQuantities((q) => ({ ...q, [product._id]: newQty }));
                                                                                        dispatch(addToCart({ ...product, quantity: newQty, supplierId: response.data.supplier._id }));

                                                                                        // if (newQty === 1) {
                                                                                        //     dispatch(removeFromCart(product._id));
                                                                                        //     dispatch(unmarkItemAsAdded(product._id));
                                                                                        //     // dispatch(cartButton(index));
                                                                                        //     return
                                                                                        // } else {
                                                                                        //     dispatch(addToCart({ ...product, quantity: newQty, supplierId: response.data.supplier._id }));
                                                                                        // }

                                                                                    }}
                                                                                >-</div>
                                                                                <input type="text" id="number" className='form-control' defaultValue={0} value={currentQty} />
                                                                                <div className="value-button" id="increase" value="Increase Value"
                                                                                    //  onClick={() => {
                                                                                    //     setQuantities((prev) => {

                                                                                    //         console.log(prev, "prev")
                                                                                    //         const updated = {
                                                                                    //             ...prev,
                                                                                    //             [product._id]: (prev[product._id] || 0) + 1, // Increment the quantity
                                                                                    //         };

                                                                                    //         // Dispatch addToCart with the updated quantity
                                                                                    //         dispatch(addToCart({
                                                                                    //             ...product,
                                                                                    //             quantity: updated[product._id]
                                                                                    //         }));

                                                                                    //         return updated;
                                                                                    //     });
                                                                                    // }}
                                                                                    onClick={() => {
                                                                                        const newQty = currentQty + 1;
                                                                                        setQuantities((q) => ({ ...q, [product._id]: newQty }));
                                                                                        dispatch(addToCart({ ...product, quantity: newQty, supplierId: response.data.supplier._id }));

                                                                                    }}
                                                                                >+</div>
                                                                            </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        )
                                                            : (
                                                                <h2 className='h5 my-4'>No products</h2>
                                                            )}
                                                    </div>
                                                </InfiniteScroll>
                                            </div>
                                        </div>
                                        <div className="tab-pane fade" id="nav-cmt-3" role="tabpanel" aria-labelledby="nav-cmt-3-tab" tabIndex={0}>
                                            {/* <div className='d-flex justify-content-between align-items-start flex-wrap gap-3'>
                                                    <div className='search_filter_blk hstack'>
                                                        <div className='search_blk position-relative'>
                                                            <input type="search" className='form-control' placeholder='Search something.....' value={requestRecievedSearch} onKeyDown={(e) => {
                                                                const value = e.target.value;
                                                                // Prevent space if the input is still empty or only contains spaces
                                                                if (e.key === ' ' && value.trim().length === 0) {
                                                                    e.preventDefault();
                                                                }
                                                            }} onChange={handleRequestRecievedSearchChange} />
                                                            <span class="search-icon"></span>
                                                        </div>
                                                        <div className='filter_blk position-relative'>
                                                            <button className='filter_btn dropdown-toggle' type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false"><img src='/assets/icons/filter-icon.svg' /></button>
                                                            <div className="filter_drop dropdown-menu dropdown-menu-end p-4">
                                                                <h3 className='filter_heading fs-6 fw-semibold mb-3'>Filter by</h3>
                                                                <div className='filter_fields mt-1'>
                                                                    <label>Type of Product</label>
                                                                    <select className='form-select' value={requestRecievedTempProductType}
                                                                        onChange={(e) => setRequestRecievedTempProductType(e.target.value)}>
                                                                        {(getSuppliersProductTypesListError || getSuppliersProductTypesListLoading) ? (
                                                                            <option>Nothing to show</option>
                                                                        ) : (
                                                                            <>
                                                                                <option>Select Category</option>
                                                                                {getSuppliersProductTypesListResponse?.data?.map((g, index) => (
                                                                                    <option key={index} value={g._id}>
                                                                                        {g.name}
                                                                                    </option>
                                                                                ))}
                                                                            </>
                                                                        )}
                                                                    </select>
                                                                </div>
                                                                <div className='filter_fields mt-1'>
                                                                    <label>Category</label>
                                                                    <select className='form-select' value={requestRecievedTempFilterCategory}
                                                                        onChange={(e) => setRequestRecievedTempFilterCategory(e.target.value)}>
                                                                        {(getSuppliersCategoryListError || getSuppliersCategoryListLoading) ? (
                                                                            <option>Nothing to show</option>
                                                                        ) : (
                                                                            <>
                                                                                <option>Select Category</option>
                                                                                {getSuppliersCategoryListResponse?.data?.map((g, index) => (
                                                                                    <option key={index} value={g._id}>
                                                                                        {g.name}
                                                                                    </option>
                                                                                ))}
                                                                            </>
                                                                        )}
                                                                    </select>
                                                                </div>
                                                                <div className='d-flex justify-content-center align-items-center flex-wrap gap-2 mt-4'>
                                                                    <button className='primary-btn p-1' onClick={() => {
                                                                        setSelectedRequestRecievedProductType(requestRecievedTempProductType);
                                                                        setSelectedRequestRecievedFilterCategory(requestRecievedTempFilterCategory);
                                                                        // trigger your filtering function or API call here
                                                                    }}>Apply</button>
                                                                    <button className='transparent-btn p-1' onClick={() => {
                                                                        setRequestRecievedTempProductType("");
                                                                        setRequestRecievedTempFilterCategory("");
                                                                        if (filterDropdownToggleRef.current) {
                                                                            const dropdown = Dropdown.getOrCreateInstance(filterDropdownToggleRef.current);
                                                                            dropdown.hide();
                                                                        }

                                                                    }}>Cancel</button>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div> */}
                                            <div className='outer_product_card_wrapper hstack align-items-start flex-wrap gap-4 mt-4'>
                                                {/* product card  */}

                                                {Array.isArray(getSuppliersRequestRecievedResponse?.data?.orders) && getSuppliersRequestRecievedResponse?.data?.orders?.length > 0 ? (
                                                    getSuppliersRequestRecievedResponse?.data?.orders?.map((order, index) => {
                                                        return (
                                                            <div className='outline_product_card_list'>
                                                                <div className='product_card_header hstack justify-content-between gap-3'>
                                                                    <h2 className='h5 fw-bold mb-0'>
                                                                        {order.requestedProducts.length} Product{order.requestedProducts.length > 1 ? 's' : ''}
                                                                    </h2>
                                                                    <div className='d-flex flex-end gap-2'>
                                                                        <span className='status_badge date_badge'>  {new Date(order.createdAt).toLocaleDateString('en-US', {
                                                                            day: 'numeric',
                                                                            month: 'short',
                                                                            year: 'numeric',
                                                                        })}</span>
                                                                        <span className='status_badge badge_pending'>{getOrderStatus(order?.status)}</span>
                                                                    </div>
                                                                </div>
                                                                <div className='inner_outline_card hstack align-items-start'>
                                                                    {order.requestedProducts.map((product, i) => (
                                                                        <div className='product_item hstack align-items-start'>
                                                                            <div className='product_img'>
                                                                                <img src={product?.image ? `${backend_url}${product?.image}` : '/assets/images/fruit-apple.png'} alt={product?.productName} />
                                                                            </div>
                                                                            <div className='product_info'>
                                                                                <div className='product_title_blk'>
                                                                                    <h3 className='product_name fs-6 fw-bold mb-0'>{product?.productName}</h3>
                                                                                </div>
                                                                                <ul className='product_title_info list-unstyled mb-0'>
                                                                                    <li><span className='card_product_title fw-medium'>Quantity -</span><span className='card_value'>{product?.quantity}</span></li>
                                                                                    <li><span className='card_product_title fw-medium'>Type -</span><span className='card_value'>{product?.productType}</span></li>
                                                                                    <li><span className='card_product_title fw-medium'>Price -</span><span className='card_value'> {product.price ? (product.unitType ? `$${product.price}/${product.unitType}` : `$${product.price}`) : "N/A"}</span></li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                <div className='product_total_blk hstack justify-content-between gap-3'>
                                                                    <h3 className='fs-6 fw-medium mb-0'>Total - {`$${order.totalPrice}`} </h3>

                                                                    {/* for now details button is disbaled */}
                                                                    <div className='d-flex flex-end gap-2'>
                                                                        <button className='primary-btn' data-bs-toggle="modal" data-bs-target="#detailModal" onClick={() => setSelectedOrder(order)}>Details</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }))
                                                    :
                                                    <h2 className='h5 my-4'>No requests</h2>}

                                            </div>

                                        </div>
                                        <div className="tab-pane fade" id="nav-cmt-2" role="tabpanel" aria-labelledby="nav-cmt-2-tab" tabIndex={0}>
                                            {/* <div className='d-flex justify-content-between align-items-start flex-wrap gap-3'>
                                                    <div className='search_filter_blk hstack'>
                                                        <div className='search_blk position-relative'>
                                                            <input type="search" className='form-control' placeholder='Search something.....' onKeyDown={(e) => {
                                                                const value = e.target.value;
                                                                // Prevent space if the input is still empty or only contains spaces
                                                                if (e.key === ' ' && value.trim().length === 0) {
                                                                    e.preventDefault();
                                                                }
                                                            }} onChange={handleRequestGeneratedSearchChange} value={requestGeneratedSearch} />
                                                            <span class="search-icon"></span>
                                                        </div>
                                                        <div className='filter_blk position-relative'>
                                                            <button className='filter_btn dropdown-toggle' type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false"><img src='/assets/icons/filter-icon.svg' /></button>
                                                            <div className="filter_drop dropdown-menu dropdown-menu-end p-4">
                                                                <h3 className='filter_heading fs-6 fw-semibold mb-3'>Filter by</h3>
                                                                <div className='filter_fields mt-1'>
                                                                    <label>Type of Product</label>
                                                                    <select className='form-select' value={requestGeneratedTempProductType}
                                                                        onChange={(e) => setRequestGeneratedTempProductType(e.target.value)}>
                                                                        {(getSuppliersProductTypesListError || getSuppliersProductTypesListLoading) ? (
                                                                            <option>Nothing to show</option>
                                                                        ) : (
                                                                            <>
                                                                                <option>Select Category</option>
                                                                                {getSuppliersProductTypesListResponse?.data?.map((g, index) => (
                                                                                    <option key={index} value={g._id}>
                                                                                        {g.name}
                                                                                    </option>
                                                                                ))}
                                                                            </>
                                                                        )}
                                                                    </select>
                                                                </div>
                                                                <div className='filter_fields mt-1'>
                                                                    <label>Category</label>

                                                                    <select className='form-select' value={requestGeneratedTempFilterCategory}
                                                                        onChange={(e) => setRequestGeneratedTempFilterCategory(e.target.value)}>
                                                                        {(getSuppliersCategoryListError || getSuppliersCategoryListLoading) ? (
                                                                            <option>Nothing to show</option>
                                                                        ) : (
                                                                            <>
                                                                                <option>Select Category</option>
                                                                                {getSuppliersCategoryListResponse?.data?.map((g, index) => (
                                                                                    <option key={index} value={g._id}>
                                                                                        {g.name}
                                                                                    </option>
                                                                                ))}
                                                                            </>
                                                                        )}
                                                                    </select>
                                                                </div>
                                                                <div className='d-flex justify-content-center align-items-center flex-wrap gap-2 mt-4'>
                                                                    <button className='primary-btn p-1' onClick={() => {
                                                                        setSelectedRequestGeneratedProductType(requestGeneratedTempProductType);
                                                                        setSelectedRequestGeneratedFilterCategory(requestGeneratedTempFilterCategory);
                                                                        // trigger your filtering function or API call here
                                                                    }}>Apply</button>
                                                                    <button className='transparent-btn p-1' onClick={() => {
                                                                        setSelectedRequestGeneratedProductType("");
                                                                        setSelectedRequestGeneratedFilterCategory("");
                                                                        if (filterDropdownToggleRef.current) {
                                                                            const dropdown = Dropdown.getOrCreateInstance(filterDropdownToggleRef.current);
                                                                            dropdown.hide();
                                                                        }

                                                                    }}>Cancel</button>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div> */}
                                            <div className='outer_product_card_wrapper hstack align-items-start flex-wrap gap-4 mt-4'>
                                                {/* product card  */}
                                                {Array.isArray(getSuppliersRequestGeneratedResponse?.data?.orders) && getSuppliersRequestGeneratedResponse?.data?.orders?.length > 0 ? (
                                                    getSuppliersRequestGeneratedResponse?.data?.orders?.map((order, index) => {
                                                        return (
                                                            <div className='outline_product_card_list'>
                                                                <div className='product_card_header hstack justify-content-between gap-3'>
                                                                    <h2 className='h5 fw-bold mb-0'>
                                                                        {order.requestedProducts.length} Product{order.requestedProducts.length > 1 ? 's' : ''}
                                                                    </h2>
                                                                    <div className='d-flex flex-end gap-2'>
                                                                        <span className='status_badge date_badge'>  {new Date(order.createdAt).toLocaleDateString('en-US', {
                                                                            day: 'numeric',
                                                                            month: 'short',
                                                                            year: 'numeric',
                                                                        })}</span>
                                                                        <span className='status_badge badge_pending'>{getOrderStatus(order?.status)}</span>
                                                                    </div>
                                                                </div>
                                                                <div className='inner_outline_card hstack align-items-start'>
                                                                    {order.requestedProducts.map((product, i) => (
                                                                        <div className='product_item hstack align-items-start'>
                                                                            <div className='product_img'>
                                                                                <img src={product?.image ? `${backend_url}${product?.image}` : '/assets/images/fruit-apple.png'} alt={product?.productName} />
                                                                            </div>
                                                                            <div className='product_info'>
                                                                                <div className='product_title_blk'>
                                                                                    <h3 className='product_name fs-6 fw-bold mb-0'>{product?.productName}</h3>
                                                                                </div>
                                                                                <ul className='product_title_info list-unstyled mb-0'>
                                                                                    <li><span className='card_product_title fw-medium'>Quantity -</span><span className='card_value'>{product?.quantity}</span></li>
                                                                                    <li><span className='card_product_title fw-medium'>Type -</span><span className='card_value'>{product?.productType}</span></li>
                                                                                    <li><span className='card_product_title fw-medium'>Price -</span><span className='card_value'> {product.price ? (product.unitType ? `$${product.price}/${product.unitType}` : `$${product.price}`) : "N/A"}</span></li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                <div className='product_total_blk hstack justify-content-between gap-3'>
                                                                    <h3 className='fs-6 fw-medium mb-0'>Total - {`$${order.totalPrice}`} </h3>

                                                                    {/* for now details button is disbaled */}
                                                                    <div className='d-flex flex-end gap-2'>
                                                                        <button className='primary-btn' data-bs-toggle="modal" data-bs-target="#detailModal" onClick={() => setSelectedOrder(order)}>Details</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })) :
                                                    <h2 className='h5 my-4'>No requests</h2>
                                                }



                                            </div>
                                            {/* status card 1 */}
                                            {/* <div className='status_card_wrapper hstack flex-wrap gap-4 mt-4'>
                                                    <div className='inner_outline_card hstack align-items-start m-0'>
                                                        <div className='product_item hstack align-items-start'>
                                                            <div className='product_img'>
                                                                <img src="/assets/images/fruit-apple.png" alt="product" />
                                                            </div>
                                                            <div className='product_info'>
                                                                <div className='product_title_blk'>
                                                                    <h3 className='product_name fs-6 fw-bold mb-0'>Apple</h3>
                                                                </div>
                                                                <ul className='product_title_info list-unstyled mb-0'>
                                                                    <li><span className='card_product_title fw-medium'>Quantity -</span><span className='card_value'>10kg</span></li>
                                                                    <li><span className='card_product_title fw-medium'>Type -</span><span className='card_value'>$3/Kg</span></li>
                                                                    <li><span className='card_product_title fw-medium'>Price -</span><span className='card_value'>$3/Kg</span></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div className='d-flex flex-end gap-2'>
                                                            <span className='status_badge date_badge'>Jan 24, 2025</span>
                                                            <span className='status_badge badge_reject'>Rejected</span>
                                                        </div>
                                                    </div>


                                                </div> */}
                                        </div>

                                        <div className="tab-pane fade" id="nav-cmt-4" role="tabpanel" aria-labelledby="nav-cmt-4-tab" tabIndex={0}>
                                            <div className='outer_product_card_wrapper hstack align-items-start flex-wrap gap-4 mt-4'>
                                                {Array.isArray(getSuppliersCompletedOrdersResponse?.data?.orders) && getSuppliersCompletedOrdersResponse?.data?.orders?.length > 0 ? (
                                                    getSuppliersCompletedOrdersResponse?.data?.orders?.map((order, index) => {
                                                        return (
                                                            <div className='outline_product_card_list'>
                                                                <div className='product_card_header hstack justify-content-between gap-3'>
                                                                    <h2 className='h5 fw-bold mb-0'>
                                                                        {order.requestedProducts.length} Product{order.requestedProducts.length > 1 ? 's' : ''}
                                                                    </h2>
                                                                    <div className='d-flex flex-end gap-2'>
                                                                        <span className='status_badge date_badge'>  {new Date(order.createdAt).toLocaleDateString('en-US', {
                                                                            day: 'numeric',
                                                                            month: 'short',
                                                                            year: 'numeric',
                                                                        })}</span>
                                                                        <span className='status_badge badge_pending'>{getOrderStatus(order?.status)}</span>
                                                                    </div>
                                                                </div>
                                                                <div className='inner_outline_card hstack align-items-start'>
                                                                    {order.requestedProducts.map((product, i) => (
                                                                        <div className='product_item hstack align-items-start'>
                                                                            <div className='product_img'>
                                                                                <img src={product?.image ? `${backend_url}${product?.image}` : '/assets/images/fruit-apple.png'} alt={product?.productName} />
                                                                            </div>
                                                                            <div className='product_info'>
                                                                                <div className='product_title_blk'>
                                                                                    <h3 className='product_name fs-6 fw-bold mb-0'>{product?.productName}</h3>
                                                                                </div>
                                                                                <ul className='product_title_info list-unstyled mb-0'>
                                                                                    <li><span className='card_product_title fw-medium'>Quantity -</span><span className='card_value'>{product?.quantity}</span></li>
                                                                                    <li><span className='card_product_title fw-medium'>Type -</span><span className='card_value'>{product?.productType}</span></li>
                                                                                    <li><span className='card_product_title fw-medium'>Price -</span><span className='card_value'> {product.price ? (product.unitType ? `$${product.price}/${product.unitType}` : `$${product.price}`) : "N/A"}</span></li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                <div className='product_total_blk hstack justify-content-between gap-3'>
                                                                    <h3 className='fs-6 fw-medium mb-0'>Total - {`$${order.totalPrice}`} </h3>

                                                                    {/* for now details button is disbaled */}
                                                                    {/* <div className='d-flex flex-end gap-2'>
                                                                    <button className='primary-btn' data-bs-toggle="modal" data-bs-target="#detailModal" onClick={() => setSelectedOrder(order)}>Details</button>
                                                                </div> */}
                                                                </div>
                                                            </div>
                                                        )
                                                    })) :
                                                    <h2 className='h5 my-4'>No orders</h2>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div >
                </section >


            )}

            <div className="modal fade" id="detailModal" tabIndex={-1} aria-labelledby="detailModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-2 fw-bold text-black" id="detailModalLabel">Order Details</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        {selectedOrder &&
                            <div className="modal-body detail-modal-body p-4">
                                <div className='outline_product_card_list'>
                                    <div className='product_card_header hstack justify-content-between gap-3'>
                                        <h2 className='h5 fw-bold mb-0'>
                                            {selectedOrder?.requestedProducts?.length} Product{selectedOrder?.requestedProducts?.length > 1 ? 's' : ''}
                                        </h2>
                                        <div className='d-flex flex-end gap-2'>
                                            <span className='status_badge date_badge'>{new Date(selectedOrder?.createdAt).toLocaleDateString('en-US', {
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric',
                                            })}</span>
                                            <span className='status_badge badge_pending'>{getOrderStatus(selectedOrder?.status)}</span>
                                        </div>
                                    </div>
                                    {selectedOrder?.requestedProducts?.length > 0 && selectedOrder?.requestedProducts?.map((product, i) => (
                                        <div className='outline_flex hstack flex-wrap gap-3'>
                                            <div className='inner_outline_card hstack align-items-start m-0'>
                                                <div className='product_item hstack align-items-start'>
                                                    <div className='product_img'>
                                                        <img src={product?.image ? `${backend_url}${product?.image}` : '/assets/images/fruit-apple.png'} alt={product?.productName} />
                                                    </div>
                                                    <div className='product_info'>
                                                        <div className='product_title_blk'>
                                                            <h3 className='product_name fs-6 fw-bold mb-0'>{product?.productName}</h3>
                                                        </div>
                                                        <ul className='product_title_info list-unstyled mb-0'>
                                                            <li><span className='card_product_title fw-medium'>Quantity -</span><span className='card_value'>{product.quantity}</span></li>
                                                            <li><span className='card_product_title fw-medium'>Type -</span><span className='card_value'>{product.productType}</span></li>
                                                            <li><span className='card_product_title fw-medium'>Price -</span><span className='card_value'>{product.price ? (product.unitType ? `$${product.price}/${product.unitType}` : `$${product.price}`) : "N/A"}</span></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    {(selectedOrder?.scheduledDate && selectedOrder?.scheduledTime) ? (
                                        <>
                                            <div className='product_card_header hstack justify-content-between gap-3 pb-0'>
                                                <h2 className='h5 fw-bold mb-0'>Scheduled Time</h2>
                                            </div>
                                            <div className='outline_flex scheduled_time_wrapper'>
                                                <div className='outline_product_card_list'>
                                                    <div className='scheduled_time_mdl_blk'>
                                                        <div className='product_info_blk hstack justify-content-between gap-3'>
                                                            <h3 className='fs-14 fw-medium mb-0'>Date</h3>
                                                            <span>-</span>
                                                            <p className='fs-14 fw-medium mb-0 text-end'>{formatDate(selectedOrder?.scheduledDate)}</p>
                                                        </div>
                                                        <div className='product_info_blk hstack justify-content-between gap-3'>
                                                            <h3 className='fs-14 fw-medium mb-0'>Expected Time</h3>
                                                            <span>-</span>
                                                            <p className='fs-14 fw-medium mb-0 text-end'>{formatTime12Hour(selectedOrder?.scheduledTime)}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : showDateTimeFields && (
                                        <div className='input_section'>
                                            <div className="input_wrapper">
                                                <label>Expected Date</label>
                                                <div className="form_field">
                                                    <input
                                                        className={`form-control ${validationErrors.date ? 'is-invalid' : ''}`}
                                                        type="date"
                                                        min={new Date().toISOString().split("T")[0]}
                                                        value={selectedDate}
                                                        onChange={(e) => {
                                                            setSelectedDate(e.target.value);
                                                            if (validationErrors.date) {
                                                                setValidationErrors(prev => ({ ...prev, date: false }));
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="input_wrapper">
                                                <label>Expected Time</label>
                                                <div className="form_field">
                                                    <input
                                                        className={`form-control ${validationErrors.time ? 'is-invalid' : ''}`}
                                                        type="time"
                                                        value={selectedTime}
                                                        onChange={(e) => {
                                                            setSelectedTime(e.target.value);
                                                            if (validationErrors.time) {
                                                                setValidationErrors(prev => ({ ...prev, time: false }));
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div className='outline_flex '>
                                        <div className='outline_product_card_list'>
                                            <div className='product_card_header hstack justify-content-between gap-3'>
                                                <h2 className='h5 fw-bold mb-0'>Order Summary</h2>
                                            </div>
                                            <div className=''>
                                                <div className='product_info_blk bg-white hstack justify-content-between gap-3'>
                                                    <h3 className='fs-14 fw-medium mb-0'>Sub Total  </h3>
                                                    <p className='fs-14 fw-medium mb-0'>${selectedOrder?.totalPrice}</p>
                                                </div>
                                                <div className='product_info_blk bg-white hstack justify-content-between gap-3'>
                                                    <h3 className='fs-14 fw-medium mb-0'>Delivery </h3>
                                                    <p className='fs-14 fw-medium mb-0' >{selectedOrder.deliveryCharges !== null ? `$${selectedOrder.deliveryCharges}` : 'To be added by supplier'}</p>
                                                </div>
                                            </div>
                                            <div className='product_total_blk hstack justify-content-between gap-3'>
                                                <h3 className='fs-6 fw-medium mb-0'>Total</h3>
                                                <p className='fs-6 fw-medium mb-0'>${selectedOrder?.totalPrice}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {((selectedOrder?.status == 0 || selectedOrder?.status == 7) && (!selectedOrder?.scheduledTime && !selectedOrder?.scheduledDate)) ?
                                        (
                                            <div className='modal_btn d-flex justify-content-end gap-2'>
                                                <button className='transparent-btn fs-14 py-2' onClick={() => handleRejectOrderRequest(selectedOrder._id, 2)}>Reject</button>
                                                <button className='primary-btn fs-14 py-2' onClick={() => {
                                                    setShowDateTimeFields(true);
                                                    if (!selectedDate || !selectedTime) {
                                                        // Optionally show validation errors
                                                        setValidationErrors({
                                                            date: !selectedDate,
                                                            time: !selectedTime
                                                        });
                                                        return;
                                                    }

                                                    // Call the API with required data
                                                    handleAcceptOrderRequest(selectedOrder._id, 1);
                                                }}>Accept</button>
                                            </div>
                                        )
                                        :
                                        (selectedOrder?.status == 0 || selectedOrder?.status == 7)
                                            ?
                                            (
                                                <div className='modal_btn d-flex justify-content-end gap-2'>
                                                    <button className='transparent-btn fs-14 py-2' onClick={() => handleRejectOrderRequest(selectedOrder._id, 2)}>Cancel</button>
                                                    {/* <button className='primary-btn fs-14 py-2' >Accept</button> */}
                                                </div>
                                            )
                                            :
                                            ''
                                    }
                                </div>
                            </div>
                        }

                    </div>
                </div>
            </div>
        </>
    )
}

export default SupplierDetail
